module.exports = __webpack_public_path__ + "static/img/upload-plus.2779b831.svg";